import {setup} from 'axios-cache-adapter'

export const axios = setup({
    maxAge: 5 * 60 * 1000,
});